import { render, staticRenderFns } from "./SoundWave.vue?vue&type=template&id=09bb3ff0"
import script from "./SoundWave.vue?vue&type=script&lang=js"
export * from "./SoundWave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports